export const getApiServerDomain = () => {
  return process.env.REACT_APP_BASE_URL || 'http://localhost:8000';
};

export const getSocketServerDomain = () => {
  return process.env.REACT_APP_BASE_SOCKET_ENDPOINT || 'http://localhost:8000';
};
